/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CsfSubcategoryRefDto
 */
export interface CsfSubcategoryRefDto {
    /**
     * 
     * @type {string}
     * @memberof CsfSubcategoryRefDto
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof CsfSubcategoryRefDto
     */
    title?: string;
}

/**
 * Check if a given object implements the CsfSubcategoryRefDto interface.
 */
export function instanceOfCsfSubcategoryRefDto(value: object): value is CsfSubcategoryRefDto {
    return true;
}

export function CsfSubcategoryRefDtoFromJSON(json: any): CsfSubcategoryRefDto {
    return CsfSubcategoryRefDtoFromJSONTyped(json, false);
}

export function CsfSubcategoryRefDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CsfSubcategoryRefDto {
    if (json == null) {
        return json;
    }
    return {
        
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function CsfSubcategoryRefDtoToJSON(json: any): CsfSubcategoryRefDto {
    return CsfSubcategoryRefDtoToJSONTyped(json, false);
}

export function CsfSubcategoryRefDtoToJSONTyped(value?: CsfSubcategoryRefDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'controlId': value['controlId'],
        'title': value['title'],
    };
}

